import {
  ORDER_STATE_ENUM,
  ORDER_REFUND_STATE_ENUM,
  ORDER_WORK_STATE_SHANG_HU_ENUM,
  OrderListActionType_ENUM,
  AllActionObjsInOrderListItem,
  E_PROMOTION_TYPE,
  SELF_PHOTO_TYPE_ENUM,
  SELF_PHOTO_NORMAL_SUPORRT_RESERVE_ENUM,
  CLOUD_PHOTO_STATE_ENUM,
  ORDER_TYPE_FOR_PERIOD
} from '@/config'
import { dateCompare, isNonEmptyArray, isNullOrEmpty } from '@/utils'
import {
  isNewAsignedMonthInLaw,
  B_ORDER_YS,
  isUnionYueSao
} from '@/business/order'
import { processCustomisedGoods } from '@/business/2-confirm'

export function getButtonList(vueInstance) {
  const { order } = vueInstance
  /**
   * "orderState": 10, //10.待支付20.待使用30.待评价40.已完成50.已取消  70.已过期
   * "refundState": 10, //10.未申请退款20.已申请退款30.退款完成40退款失败(可选项)
   * "barcodeList"[0]."workState":30,
   * //仅限签约月嫂 上户状态 0:待申请上户 30:已申请上户 35:驳回上户 40:已确认上户
   */

  let {
    orderState,
    refundState,
    workState,
    groupId,
    channelType,
    workerType = 0,
    level4CategoryId,
    selfPhotoType,
    supportReserve,
    reserveRecord,
    cloudPhotoState,
    payPeriodType
  } = order

  // mock test
  // orderState = 20
  // selfPhotoType = 3
  // cloudPhotoState = 3
  // payPeriodType =20

  orderState = orderState && +orderState
  refundState = refundState && +refundState

  let currStateActionBtns = []

  if (ORDER_STATE_ENUM.PENDING_PAY == orderState) {
    // 待支付 btn：立即支付
    currStateActionBtns.push(
      AllActionObjsInOrderListItem.get(OrderListActionType_ENUM.TO_PAY)
    )
  } else if (ORDER_STATE_ENUM.CANCELED == orderState) {
    // 已取消 btn：删除订单
    currStateActionBtns.push(
      AllActionObjsInOrderListItem.get(OrderListActionType_ENUM.TO_DEL_ORDER)
    )
  } else if (ORDER_REFUND_STATE_ENUM.SUCCESSED == refundState) {
    // 退款成功后的已取消 btn：删除订单
    currStateActionBtns.push(
      AllActionObjsInOrderListItem.get(OrderListActionType_ENUM.TO_DEL_ORDER)
    )
  } else {
    // 已确认上户 btn：服务日志
    // 待评价 btn：立即评价
    // 虚拟月嫂不出现btn服务日志
    if ((workState == 0 || workState) && !B_ORDER_YS.isVirtual(workerType)) {
      if (ORDER_WORK_STATE_SHANG_HU_ENUM.YI_QUEREN_SHANGHU == workState) {
        currStateActionBtns.push(
          AllActionObjsInOrderListItem.get(
            OrderListActionType_ENUM.TO_SERVICE_LOG
          )
        )
      }
    }

    // 拼团
    if (
      !isNullOrEmpty(groupId) &&
      +channelType === 4 &&
      orderState > ORDER_STATE_ENUM.PENDING_PAY &&
      orderState !== ORDER_STATE_ENUM.CANCELED
    ) {
      currStateActionBtns.push(
        AllActionObjsInOrderListItem.get(
          OrderListActionType_ENUM.TO_GROUP_DETAIL
        )
      )
    }

    const { refOrderGive = [] } = order
    if (isNonEmptyArray(refOrderGive)) {
      // v21.06.01 送赠品
      /**
             * {"activityId":"满赠活动id"
                "giveSkuId":123  满赠商品skuId
                "giveSpuId':123 满赠商品spuId
                "giveSkuName":"小东西 500g” 满赠商品规格名称
                "giveSpuName":"小东西" 满赠商品名称
                "promotionName":华为p30 满赠活动商品名称
                "refOrder":1 赠品是否需要下单 0 不需要 1需要
                "endTime":"2021-06-01 00:00:00" //活动结束时间
                "specSpu":0 //是否定制赠品商品
            }
            */
      const refOrder = refOrderGive.find(x => +x.refOrder === 1)
      if (refOrder) {
        const { giveSpuId: spuId, giveSkuId: skuId, endTime } = refOrder
        if (dateCompare(endTime)) {
          btns.push({
            txt: '获取赠品',
            handleClick() {
              /** 取的是母单的商家ID，存疑 lyf*/
              processCustomisedGoods({
                spuId,
                skuId,
                businessId,
                endTime,
                relOrderId: orderId
              })
            }
          })
        }
      }
    }

    if (ORDER_STATE_ENUM.WAITING_4_EVALUATE == orderState) {
      currStateActionBtns.push(
        AllActionObjsInOrderListItem.get(OrderListActionType_ENUM.TO_COMMENT)
      )
    }
  }

  // "预约拍摄"，“修改预约”，“我的相册”--非二销扫码付、非加修补充订单的云摄影的自营摄影
  if (
    SELF_PHOTO_TYPE_ENUM.NORMAL == selfPhotoType &&
    SELF_PHOTO_NORMAL_SUPORRT_RESERVE_ENUM.YES == supportReserve
  ) {
    //非二销扫码付、支持预约自营摄影
    if (ORDER_STATE_ENUM.TO_BE_USED == orderState) {
      // 待使用
      if (!reserveRecord) {
        currStateActionBtns.unshift(
          AllActionObjsInOrderListItem.get(
            OrderListActionType_ENUM.TO_RESERVE_DATETIME_TAKE_PHOTO
          )
        )
      } else {
        currStateActionBtns.unshift(
          AllActionObjsInOrderListItem.get(
            OrderListActionType_ENUM.TO_MODIFY_DATETIME_TAKE_PHOTO
          )
        )
      }
    }
  } else if (SELF_PHOTO_TYPE_ENUM.CLOUD == selfPhotoType) {
    // 云摄影
    if (ORDER_TYPE_FOR_PERIOD.CLOUD_PHOTO_APPEND_CHILD_ORDER != payPeriodType) {
      // 非加修补充单
      if (CLOUD_PHOTO_STATE_ENUM.STEP2_RESERVE_STAGE == cloudPhotoState) {
        // 预约拍摄阶段
        if (ORDER_STATE_ENUM.TO_BE_USED == orderState) {
          // 待使用
          if (!reserveRecord) {
            currStateActionBtns.unshift(
              AllActionObjsInOrderListItem.get(
                OrderListActionType_ENUM.TO_RESERVE_DATETIME_TAKE_PHOTO
              )
            )
          } else {
            currStateActionBtns.unshift(
              AllActionObjsInOrderListItem.get(
                OrderListActionType_ENUM.TO_MODIFY_DATETIME_TAKE_PHOTO
              )
            )
          }
        }
      } else if (
        CLOUD_PHOTO_STATE_ENUM.STEP3_PHOTO_TAKING_STAGE == cloudPhotoState ||
        CLOUD_PHOTO_STATE_ENUM.STEP4_CHOOSE_REPAIR_PHOTO_STAGE ==
          cloudPhotoState ||
        CLOUD_PHOTO_STATE_ENUM.STEP5_REPAIR_STAGE == cloudPhotoState ||
        CLOUD_PHOTO_STATE_ENUM.STEP6_REPAIR_COMPLETE == cloudPhotoState
      ) {
        // 预约拍摄后的其他阶段节点

        currStateActionBtns.unshift(
          AllActionObjsInOrderListItem.get(OrderListActionType_ENUM.TO_MY_ALBUM)
        )
      }
    }
  }

  return currStateActionBtns
}
